var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-page"},[_c('div',{staticClass:"container overflow-hidden text-center"},[_vm._m(0),_c('div',[_c('a',{staticClass:"robo-24-500",attrs:{"href":"javascript:;"},on:{"click":_vm.goToHome}},[_vm._v("Về trang chủ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":require("../../public/assets/images/404.png"),"alt":""}})])
}]

export { render, staticRenderFns }